var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 79.9999C50.7394 79.9999 52.96 77.6897 52.96 74.8399C52.96 71.9901 50.7394 69.6799 48 69.6799C45.2607 69.6799 43.04 71.9901 43.04 74.8399C43.04 77.6897 45.2607 79.9999 48 79.9999Z",
    fill: "#C18344",
    stroke: "#C18344",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3604 59.5601C36.4004 55.5601 41.9204 53.1201 48.0004 53.1201C54.0804 53.1201 59.6004 55.5601 63.6404 59.5601",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1602 46.0001C27.4802 38.9201 37.2002 34.5601 48.0002 34.5601C58.8002 34.5601 68.5602 38.9201 75.8802 46.0001",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32.48C18.48 22.24 32.52 16 48 16C63.48 16 77.52 22.24 88 32.48",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.4dcd5d11a23ebaac26f9d3971d2cc5cc.svg";
export { ForwardRef as ReactComponent };